import secureLocalStorage from "react-secure-storage";

export class StorageAdapter {

    static getItem(key: string): string {
        try {

            let value = secureLocalStorage.getItem(key);

            let str = ''
            if (value === undefined) {
                str = '';
            } else if (typeof value === 'number') {
                str = value.toString();
            } else if (typeof value === 'boolean') {
                str = value ? 'true' : 'false';
            } else if (typeof value === 'string') {
                str = value;
            }

            return str;

        } catch (error) {
            return '';
        }
    }

    static setItem(key: string, value: string): void {
        try {

            secureLocalStorage.setItem(key, value);

        } catch (error) {
            throw new Error(`Error seting item ${key} ${value}`);
        }
    }

    static removeItem(key: string): void {
        try {

            secureLocalStorage.removeItem(key);

        } catch (error) {
            throw new Error(`Error removing item ${key}`);
        }
    }

}